import {
	Component,
	Input,
	OnDestroy,
	Output,
	EventEmitter,
	OnChanges
} from '@angular/core';
import { Subscription } from 'rxjs';
import { KngBanner, KngBannerState } from './definitions';
import { KngBannerService } from './kng-banner.service';
import { isRaymond } from '../../constants/environment.constant';

@Component({
	selector: 'kng-banner',
	templateUrl: './template/kng-banner.component.html',
	styleUrls: ['./template/kng-banner.component.scss']
})
export class KngBannerComponent implements KngBanner, OnDestroy, OnChanges
{
	private subscriptions: Subscription = new Subscription();
  @Input() state :KngBannerState = {
  	bannerIcon: {
  		altText: '',
  		iconPath: ''
  	},
  	bannerMessage: '',
  	closeIcon: {
  		altText: '',
  		iconPath: ''
  	},
  	open: false,
  	startDate: new Date(),
  	endDate: new Date()
  };
  get isRaymond(): boolean
  {
  	return isRaymond || false;
  }

  @Output() stateChanged: EventEmitter<KngBannerState> = new EventEmitter<KngBannerState>();
  @Output() bannerClickEvent: EventEmitter<MouseEvent | TouchEvent> = new EventEmitter<MouseEvent | TouchEvent>();
  @Output() bannerClosed: EventEmitter<number> = new EventEmitter<number>();
  @Output() alertBannerClosed: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() closeBanner: EventEmitter<boolean> = new EventEmitter<boolean>();
  constructor(private service: KngBannerService) {}

  ngOnChanges(): void 
  {
  	this.initSubscriptions();
  }
  ngOnDestroy(): void
  {
  	this.destroySubscriptions();
  }
  

  private initSubscriptions(): void
  {
  	const stateChangeSubs: Subscription = this.service.stateChanged.subscribe(
  		(next: KngBannerState) => this.stateChanged.emit(next)
  	);
  	this.subscriptions.add(stateChangeSubs);
  }
  private destroySubscriptions(): void
  {
  	this.subscriptions.unsubscribe();
  }

  public hideBanner()
  {
  	this.state.open = false;
  	this.closeBanner.emit(true);
  }
  bannerClickHandler(event: MouseEvent | TouchEvent)
  {
 	this.bannerClickEvent.emit(event);
  }
  headerBannerCloseHandler(index: number)
  {
  	this.bannerClosed.emit(index);
  	this.alertBannerClosed.emit(true);
  }
  handleBannerStyle(index: number)
  {
  	const result=  this.state.alertBanner?.findIndex(val => val.display.toLocaleLowerCase() === 'true');
  	if (result !== -1)
  		return index === result;
  	else
  		return false;
  }
}
